import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";
import { Card, CardBody, Col, Container, Row, Button } from "reactstrap";
import moment from "moment";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider from "react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import "assets/scss/table.scss";

import Breadcrumbs from "components/Common/Breadcrumb";
import { getSchemeAnalytesList } from "store/results/actions";
import { postValues } from "store/results/actions";
import { getQualitativeAssign } from "store/results/actions";
import "assets/scss/table.scss";

class ReportValues extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      SchemeAnalytesList: [],
      typeOptions: ["Equivocal", "Positive", "Negative"],
      valueOptions: [0, 1, 2],
      selectedTypes: {},
      selectedPositiveValues: {},
      selectedNegativeValues: {},
      selectedEquivocalValues: {},
      selectedValues: {},
      submissionSuccess: null, // Track success/failure message
      disabledDropdowns: {}, // ✅ Track which dropdowns are disabled for each analyte
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      organization_name: "",
    };
  }

  // ✅ Check if a dropdown should be disabled
  isDropdownDisabled = (analyteId, currentType) => {
    const {
      selectedPositiveValues,
      selectedNegativeValues,
      selectedEquivocalValues,
    } = this.state;

    const hasPositive = selectedPositiveValues[analyteId] === 5;
    const hasNegative = selectedNegativeValues[analyteId] === 5;
    const hasEquivocal = selectedEquivocalValues[analyteId] === 5;

    console.log(`🔒 isDropdownDisabled(${analyteId}, ${currentType}):`, {
      hasPositive,
      hasNegative,
      hasEquivocal,
      positiveValue: selectedPositiveValues[analyteId],
      negativeValue: selectedNegativeValues[analyteId],
      equivocalValue: selectedEquivocalValues[analyteId],
    });

    // Agar current dropdown mein value 5 hai, to ye disabled nahi hoga
    if (currentType === "positive" && hasPositive) return false;
    if (currentType === "negative" && hasNegative) return false;
    if (currentType === "equivocal" && hasEquivocal) return false;

    // Agar koi aur dropdown mein value 5 hai, to current dropdown disable hoga
    if (currentType === "positive" && (hasNegative || hasEquivocal)) {
      console.log(`🔒 Disabling positive for ${analyteId}`);
      return true;
    }
    if (currentType === "negative" && (hasPositive || hasEquivocal)) {
      console.log(`🔒 Disabling negative for ${analyteId}`);
      return true;
    }
    if (currentType === "equivocal" && (hasPositive || hasNegative)) {
      console.log(`🔒 Disabling equivocal for ${analyteId}`);
      return true;
    }

    return false;
  };

  // ✅ Get columns with current state
  getColumns = () => {
    return [
      {
        text: "Analyte",
        dataField: "name",
        sort: true,
        formatter: (cellContent, analyte) => {
          const { organization_name } = this.state;
          const url = `/${organization_name}/displayValues/${analyte.id}?round_id=${this.props.match.params.id}`;
          return (
            <div className="text-start">
              <Link to={url} className="text-decoration-none">
                {analyte.name}
              </Link>
            </div>
          );
        },
      },
      {
        text: "",
        dataField: "positivevalue",
        formatter: (cellContent, analyte) => {
          const isDisabled = this.isDropdownDisabled(analyte.id, "positive");
          const selectedValue = this.state.selectedPositiveValues[analyte.id];
          const hasValue = selectedValue !== undefined && selectedValue !== "";
          return (
            <div className="d-flex">
              <span className="me-2 align-self-center">Positive</span>
              <select
                key={`positive-${analyte.id}-${selectedValue}`}
                className="form-select"
                style={{
                  backgroundColor: hasValue ? "#deebff" : "",
                  borderColor: hasValue ? "#5297ff" : "",
                  fontWeight: hasValue ? "bold" : "normal",
                }}
                onChange={e =>
                  this.handleValueChange(analyte.id, e.target.value, "positive")
                }
                defaultValue={
                  selectedValue !== undefined && selectedValue !== ""
                    ? selectedValue
                    : ""
                }
                disabled={isDisabled}
              >
                <option value="">Select Value</option>
                <option value={5}>5</option>
                <option value={0}>0</option>
              </select>
            </div>
          );
        },
      },
      {
        text: "",
        dataField: "negativevalue",
        formatter: (cellContent, analyte) => {
          const isDisabled = this.isDropdownDisabled(analyte.id, "negative");
          const selectedValue = this.state.selectedNegativeValues[analyte.id];
          const hasValue = selectedValue !== undefined && selectedValue !== "";
          return (
            <div className="d-flex">
              <span className="me-2 align-self-center">Negative</span>
              <select
                key={`negative-${analyte.id}-${selectedValue}`}
                className="form-select"
                style={{
                  backgroundColor: hasValue ? "#deebff" : "",
                  borderColor: hasValue ? "#5297ff" : "",
                  fontWeight: hasValue ? "bold" : "normal",
                }}
                onChange={e =>
                  this.handleValueChange(analyte.id, e.target.value, "negative")
                }
                defaultValue={
                  selectedValue !== undefined && selectedValue !== ""
                    ? selectedValue
                    : ""
                }
                disabled={isDisabled}
              >
                <option value="">Select Value</option>
                <option value={5}>5</option>
                <option value={0}>0</option>
              </select>
            </div>
          );
        },
      },
      {
        text: "",
        dataField: "equivocalvalue",
        formatter: (cellContent, analyte) => {
          const isDisabled = this.isDropdownDisabled(analyte.id, "equivocal");
          const selectedValue = this.state.selectedEquivocalValues[analyte.id];
          const hasValue = selectedValue !== undefined && selectedValue !== "";
          return (
            <div className="d-flex">
              <span className="me-2 align-self-center">Equivocal</span>
              <select
                key={`equivocal-${analyte.id}-${selectedValue}`}
                className="form-select"
                style={{
                  backgroundColor: hasValue ? "#deebff" : "",
                  borderColor: hasValue ? "#5297ff" : "",
                  fontWeight: hasValue ? "bold" : "normal",
                }}
                onChange={e =>
                  this.handleValueChange(
                    analyte.id,
                    e.target.value,
                    "equivocal"
                  )
                }
                defaultValue={
                  selectedValue !== undefined && selectedValue !== ""
                    ? selectedValue
                    : ""
                }
                disabled={isDisabled}
              >
                <option value="">Select Value</option>
                <option value={5}>5</option>
                <option value={0}>0</option>
              </select>
            </div>
          );
        },
      },
      {
        text: "Select Status",
        dataField: "status",
        formatter: (cell, analyte) => (
          <select
            className="form-select"
            value={analyte.status || ""}
            onChange={e => this.handleStatusChange(analyte.id, e.target.value)}
          >
            <option value="">Select</option>
            <option value="Abrogated">Reject</option>
          </select>
        ),
      },
    ];
  };

  componentDidMount() {
    const { organization_name } = this.props.match.params;

    if (!this.state.organization_name) {
      this.setState({ organization_name });
    }

    const { onGetSchemeAnalyte, onGetQualitativeAssign } = this.props;
    const id = this.props.match.params.id;

    // ✅ Fetch list of analytes
    onGetSchemeAnalyte(id);

    // ✅ Fetch qualitative assign values
    const payload = { round_id: id };
    onGetQualitativeAssign(payload);
  }

  componentDidUpdate(prevProps) {
    const { SchemeAnalytesList, QualitativeAssign } = this.props;

    if (
      prevProps.SchemeAnalytesList !== SchemeAnalytesList ||
      prevProps.QualitativeAssign !== QualitativeAssign
    ) {
      const selectedPositiveValues = {};
      const selectedNegativeValues = {};
      const selectedEquivocalValues = {};

      const qualitativeAssignArray = Array.isArray(QualitativeAssign)
        ? QualitativeAssign
        : [];

      console.log("🔍 QualitativeAssign Data:", QualitativeAssign);

      const sortedList = [...SchemeAnalytesList].sort((a, b) =>
        a.name.localeCompare(b.name)
      );

      sortedList.forEach(analyte => {
        const existing = qualitativeAssignArray.find(
          q => q.analyte_id === analyte.id
        );
        analyte.status = existing?.status || "";
        // ✅ Convert to number for proper comparison
        const positiveType = existing?.positivetype
          ? Number(existing.positivetype)
          : null;
        const negativeType = existing?.negativetype
          ? Number(existing.negativetype)
          : null;
        const equivocalType = existing?.equivocaltype
          ? Number(existing.equivocaltype)
          : null;

        console.log(`📊 Analyte ${analyte.name}:`, {
          positiveType,
          negativeType,
          equivocalType,
          positiveIs5: positiveType === 5,
          negativeIs5: negativeType === 5,
          equivocalIs5: equivocalType === 5,
        });

        // ✅ Agar positive mein 5 hai, to baaki empty
        if (positiveType === 5) {
          selectedPositiveValues[analyte.id] = 5;
          selectedNegativeValues[analyte.id] = "";
          selectedEquivocalValues[analyte.id] = "";
          console.log(`✅ Set positive=5 for ${analyte.name}, others empty`);
        }
        // ✅ Agar negative mein 5 hai, to baaki empty
        else if (negativeType === 5) {
          selectedPositiveValues[analyte.id] = "";
          selectedNegativeValues[analyte.id] = 5;
          selectedEquivocalValues[analyte.id] = "";
          console.log(`✅ Set negative=5 for ${analyte.name}, others empty`);
        }
        // ✅ Agar equivocal mein 5 hai, to baaki empty
        else if (equivocalType === 5) {
          selectedPositiveValues[analyte.id] = "";
          selectedNegativeValues[analyte.id] = "";
          selectedEquivocalValues[analyte.id] = 5;
          console.log(`✅ Set equivocal=5 for ${analyte.name}, others empty`);
        }
        // ✅ Agar kisi mein bhi 5 nahi, to sab values as-is (but convert to number)
        else {
          selectedPositiveValues[analyte.id] = positiveType || "";
          selectedNegativeValues[analyte.id] = negativeType || "";
          selectedEquivocalValues[analyte.id] = equivocalType || "";
          console.log(`📝 Set all values as-is for ${analyte.name}`);
        }
      });

      console.log("🎯 Final State:", {
        selectedPositiveValues,
        selectedNegativeValues,
        selectedEquivocalValues,
      });

      if (SchemeAnalytesList.length > 0) {
        this.setState({
          SchemeAnalytesList: sortedList,
          selectedPositiveValues,
          selectedNegativeValues,
          selectedEquivocalValues,
        });
      }
    }
  }
  handleStatusChange = (analyteId, value) => {
    this.setState(prevState => ({
      SchemeAnalytesList: prevState.SchemeAnalytesList.map(item =>
        item.id === analyteId ? { ...item, status: value } : item
      ),
    }));
  };
  handleTypeChange = (analyteId, value) => {
    this.setState(prevState => ({
      selectedTypes: {
        ...prevState.selectedTypes,
        [analyteId]: value,
      },
    }));
  };

  handleValueChange = (analyteId, value, valueType) => {
    const val = value === "" ? "" : Number(value);

    this.setState(prevState => {
      const updatedState = {
        selectedPositiveValues: { ...prevState.selectedPositiveValues },
        selectedNegativeValues: { ...prevState.selectedNegativeValues },
        selectedEquivocalValues: { ...prevState.selectedEquivocalValues },
      };

      // ✅ Agar user ne value select ki hai (not empty)
      if (val !== "") {
        // Set selected value
        if (valueType === "positive") {
          updatedState.selectedPositiveValues[analyteId] = val;
          // ✅ Only clear other dropdowns if value is 5
          if (val === 5) {
            updatedState.selectedNegativeValues[analyteId] = "";
            updatedState.selectedEquivocalValues[analyteId] = "";
          }
        } else if (valueType === "negative") {
          updatedState.selectedNegativeValues[analyteId] = val;
          // ✅ Only clear other dropdowns if value is 5
          if (val === 5) {
            updatedState.selectedPositiveValues[analyteId] = "";
            updatedState.selectedEquivocalValues[analyteId] = "";
          }
        } else if (valueType === "equivocal") {
          updatedState.selectedEquivocalValues[analyteId] = val;
          // ✅ Only clear other dropdowns if value is 5
          if (val === 5) {
            updatedState.selectedPositiveValues[analyteId] = "";
            updatedState.selectedNegativeValues[analyteId] = "";
          }
        }
      } else {
        // ✅ Agar user ne empty select kiya (deselect)
        if (valueType === "positive") {
          updatedState.selectedPositiveValues[analyteId] = "";
        } else if (valueType === "negative") {
          updatedState.selectedNegativeValues[analyteId] = "";
        } else if (valueType === "equivocal") {
          updatedState.selectedEquivocalValues[analyteId] = "";
        }
      }

      return updatedState;
    });
  };

  handleSubmit = async analyte => {
    const {
      selectedPositiveValues,
      selectedNegativeValues,
      selectedEquivocalValues,
      user_id,
    } = this.state;

    const round_id = this.props.match.params.id;
    const analyte_id = analyte.id;

    const valuesToSubmit = [];

    if (selectedPositiveValues[analyte_id] !== undefined) {
      valuesToSubmit.push({
        analyte_id,
        account_id: user_id,
        type: "positive",
        value: selectedPositiveValues[analyte_id],
      });
    }

    if (selectedNegativeValues[analyte_id] !== undefined) {
      valuesToSubmit.push({
        analyte_id,
        account_id: user_id,
        type: "negative",
        value: selectedNegativeValues[analyte_id],
      });
    }

    if (selectedEquivocalValues[analyte_id] !== undefined) {
      valuesToSubmit.push({
        analyte_id,
        account_id: user_id,
        type: "equivocal",
        value: selectedEquivocalValues[analyte_id],
      });
    }

    if (valuesToSubmit.length === 0) {
      this.setState({ submissionSuccess: false });
      return;
    }

    try {
      // 🔁 Send each value separately
      await Promise.all(
        valuesToSubmit.map(payload =>
          this.props.onPostValues(payload, round_id)
        )
      );

      this.setState({
        submissionSuccess: true,
        selectedPositiveValues: {},
        selectedNegativeValues: {},
        selectedEquivocalValues: {},
      });
    } catch (error) {
      this.setState({ submissionSuccess: false });
    }

    setTimeout(() => {
      this.setState({ submissionSuccess: null });
    }, 3000);
  };

  handleSubmitAll = async () => {
    const {
      selectedPositiveValues,
      selectedNegativeValues,
      selectedEquivocalValues,
      user_id,
      SchemeAnalytesList,
      scheme_id, // ✅ Get from state
      cycle_id, // ✅ Get from state
    } = this.state;

    const round_id = this.props.match.params.id;
    const valuesToSubmit = [];

    SchemeAnalytesList.forEach(analyte => {
      const analyte_id = analyte.id;
      const payload = {
        analyte_id,
        account_id: user_id,
        round_id,
        scheme_id, // ✅ include scheme_id
        cycle_id, // ✅ include cycle_id
      };
      if (analyte.status && analyte.status !== "") {
        payload.status = analyte.status;
      }

      if (
        selectedPositiveValues[analyte_id] !== undefined &&
        selectedPositiveValues[analyte_id] !== ""
      ) {
        payload.positivetype = selectedPositiveValues[analyte_id];
      }

      if (
        selectedNegativeValues[analyte_id] !== undefined &&
        selectedNegativeValues[analyte_id] !== ""
      ) {
        payload.negativetype = selectedNegativeValues[analyte_id];
      }

      if (
        selectedEquivocalValues[analyte_id] !== undefined &&
        selectedEquivocalValues[analyte_id] !== ""
      ) {
        payload.equivocaltype = selectedEquivocalValues[analyte_id];
      }

      valuesToSubmit.push(payload);
    });

    if (valuesToSubmit.length === 0) {
      this.setState({ submissionSuccess: false });
      return;
    }

    try {
      await Promise.all(
        valuesToSubmit.map(payload =>
          this.props.onPostValues(payload, round_id)
        )
      );

      this.setState({
        submissionSuccess: true,
        selectedPositiveValues: {},
        selectedNegativeValues: {},
        selectedEquivocalValues: {},
      });
    } catch (error) {
      this.setState({ submissionSuccess: false });
    }

    setTimeout(() => {
      this.setState({ submissionSuccess: null });
    }, 3000);
  };

  onPaginationPageChange = page => {
    if (
      this.node &&
      this.node.current &&
      this.node.current.props &&
      this.node.current.props.pagination &&
      this.node.current.props.pagination.options
    ) {
      this.node.current.props.pagination.options.onPageChange(page);
    }
  };

  render() {
    const {
      closing_date,
      rounds,
      schemeName,
      scheme_type,
      cycle_no,
      round_issuedate,
      round_status,
    } = this.props;
    const { SchemeAnalytesList, submissionSuccess } = this.state;
    const pageOptions = {
      sizePerPage: 50,
      totalSize: SchemeAnalytesList.length, // Use correct list length
      custom: true,
    };

    const columns = this.getColumns(); // ✅ Get columns dynamically

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>{/* <title>Report Values | Your App</title> */}</MetaTags>
          <Container fluid>
            <Row className="mb-3">
              <Col className="text-start">
                <Button
                  color="primary"
                  onClick={() => this.props.history.goBack()}
                >
                  ← Back
                </Button>
              </Col>
            </Row>
            <div className="container">
              <Row className="mb-4">
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Round:</span>
                    <span>
                      <strong>{rounds ? rounds : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Scheme Name:</span>
                    <span>
                      <strong>{schemeName ? schemeName : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Scheme Type:</span>
                    <span>
                      <strong>{scheme_type ? scheme_type : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Cycle No:</span>
                    <span>
                      <strong>{cycle_no ? cycle_no : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Closing Date:</span>
                    <span>
                      <strong>
                        {closing_date
                          ? moment(closing_date).format("DD-MMM-YY, h:mm A")
                          : "N/A"}
                      </strong>
                    </span>
                  </div>
                </Col>

                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Issued Date:</span>
                    <span>
                      <strong>
                        {round_issuedate
                          ? moment(round_issuedate).format(
                              "DD-MMM-YY, h:mm A"
                            )
                          : "N/A"}
                      </strong>
                    </span>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">Status:</span>
                    <span>
                      <strong>{round_status ? round_status : "N/A"}</strong>
                    </span>
                  </div>
                </Col>
              </Row>
            </div>
            <Row className="justify-content-center align-item-center">
              <Col lg="10">
                <p>
                  <strong>
                    Please select the True Value for each analyte, the Score for
                    True value will be 5.
                  </strong>
                </p>
                <p>
                  <strong>
                    Just define the True values, by assigning Score 5 all
                    Analytes False values will be assign Score 0 automatically.
                  </strong>
                </p>
                <Card>
                  <CardBody>
                    {submissionSuccess !== null && (
                      <div
                        className={`alert ${
                          submissionSuccess ? "alert-success" : "alert-danger"
                        }`}
                        role="alert"
                      >
                        {submissionSuccess
                          ? "Values submitted successfully!"
                          : "Failed to submit values."}
                      </div>
                    )}
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={columns}
                      data={SchemeAnalytesList}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={columns}
                          data={SchemeAnalytesList}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <div className="text-end mt-3">
                                <button
                                  className="btn btn-primary"
                                  onClick={this.handleSubmitAll}
                                >
                                  Submit All
                                </button>
                              </div>
                              <div className="table-responsive">
                                <BootstrapTable
                                  id="printable-table"
                                  keyField="id"
                                  key={
                                    JSON.stringify(
                                      this.state.selectedPositiveValues
                                    ) +
                                    JSON.stringify(
                                      this.state.selectedNegativeValues
                                    ) +
                                    JSON.stringify(
                                      this.state.selectedEquivocalValues
                                    )
                                  }
                                  ref={this.node}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  classes={"table table-bordered table-hover"}
                                  {...toolkitprops.baseProps}
                                  {...paginationTableProps}
                                />

                                <div className="float-end">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                    onPageChange={this.onPaginationPageChange}
                                  />
                                </div>
                              </div>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

ReportValues.propTypes = {
  match: PropTypes.object,
  className: PropTypes.any,
  SchemeAnalytesList: PropTypes.array,

  onGetSchemeAnalyte: PropTypes.func,
  QualitativeAssign: PropTypes.array,
  onGetQualitativeAssign: PropTypes.func,
  onPostValues: PropTypes.func,
  rounds: PropTypes.string,
  issue_date: PropTypes.object,
  schemeName: PropTypes.string,
  scheme_type: PropTypes.string,
  closing_date: PropTypes.string,
  round_issuedate: PropTypes.string,
  round_status: PropTypes.string,
  cycle_no: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).i,
};
const mapStateToProps = state => {
  const schemeState = state.SchemeAnalytesList; // 👈 Cleaner reference

  return {
    SchemeAnalytesList: schemeState.SchemeAnalytesList,
    QualitativeAssign: schemeState.QualitativeAssign?.data || [],

    // ✅ Add these round/scheme metadata values
    rounds: schemeState.rounds,
    rounds_instance: schemeState.rounds_instance,
    closing_date: schemeState.closing_date,
    Statistics: schemeState.Statistics,
    schemeName: schemeState.schemeName, // ⚡️ used in render()
    scheme_type: schemeState.schemeType,
    round_issuedate: schemeState.issue_date,
    round_status: schemeState.round_status,
    cycle_no: schemeState.cycle_no,
  };
};

const mapDispatchToProps = dispatch => ({
  onGetSchemeAnalyte: id => dispatch(getSchemeAnalytesList(id)),
  onPostValues: (result, id) => dispatch(postValues(result, id)),

  // ✅ New action for qualitative assign
  onGetQualitativeAssign: payload => dispatch(getQualitativeAssign(payload)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ReportValues));
